import React from "react";
import { Box, Icon, Typography } from "@mui/material";

import ImageFileSelectWrapper from "./image-file-select-wrapper";

const DisplayNoImageSelected = () => {
  return (
    <ImageFileSelectWrapper>
      <Box
        height={{ xs: 350, md: 250 }}
        width={{ xs: "100%", md: 300 }}
        component="span"
        sx={{
          border: "1px dashed lightgrey",
          borderColor: "#F4A600",
          borderRadius: "8px",
          display: "grid",
          placeItems: "center",
          p: { xs: 2, md: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Icon
            fontSize="large"
            sx={{
              color: "#F4A600",
              fontSize: { xs: "2rem", md: "2.75rem" },
            }}
          >
            add_photo_alternate
          </Icon>
          <Typography variant="body2" fontWeight={600}>
            Click to upload your image
          </Typography>
          {/* <Typography variant="body2">or drag and drop here</Typography> */}
        </Box>
      </Box>
    </ImageFileSelectWrapper>
  );
};

export default DisplayNoImageSelected;
